import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleDrive = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 3.3271)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_0_52",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 36,
				height: 34,
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_2",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M10.8707 4.11409C14.0392 -1.37126 21.9608 -1.37147 25.1293 4.11409L34.8849 21.0034C38.0533 26.489 34.0926 33.3458 27.7555 33.3458H8.2445C1.90735 33.3458 -2.05334 26.489 1.11513 21.0034L10.8707 4.11409Z",
						fill: "white"
					})
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_0_52)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path",
						d: "M42.0258 33.35H22.1199L18.0006 26.2188L27.9536 8.98776L42.0258 33.35Z",
						fillRule: "evenodd",
						clipRule: "evenodd",
						fill: "url(#paint0_linear_0_52)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2",
						d: "M-6.02852 33.3469L8.04371 8.9847V8.98513L3.92596 16.1146H12.1623L22.1161 33.3465L-6.0283 33.3467L-6.02852 33.3469Z",
						fillRule: "evenodd",
						clipRule: "evenodd",
						fill: "url(#paint1_linear_0_52)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_3",
						d: "M18.0016 -8.24652L27.9552 8.98601L23.8368 16.1159H3.92939L18.0016 -8.24652Z",
						fillRule: "evenodd",
						clipRule: "evenodd",
						fill: "url(#paint2_linear_0_52)"
					})
				]
			})]
		}), /* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_0_52",
				x1: 38.8926,
				y1: 31.9599,
				x2: 19.6811,
				y2: 20.4206,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .09,
					stopColor: "#FFE921"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEC700"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_0_52",
				x1: 19.3108,
				y1: 29.7888,
				x2: 12.2339,
				y2: 25.5136,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#A9A8FF" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .33,
						stopColor: "#6D97FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#3186FF"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_0_52",
				x1: 14.107,
				y1: 9.65813,
				x2: 7.93159,
				y2: 13.7779,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0EBC5F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#78C9FF"
				})]
			})
		] })]
	})
});
export default SvgGoogleDrive;
